var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTgpTrophy = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55728 1.9548H2.21725C1.42451 1.9548 0.666504 2.57419 0.666504 3.64942V4.3483C0.666504 4.91492 0.718611 5.33488 0.950469 5.89036C1.36765 6.88498 2.33654 7.87779 3.85468 7.93104L4.72769 7.45938L3.6007 6.98772C3.3187 6.95036 2.446 6.76028 1.88593 5.795C1.47186 5.08287 1.53462 3.95487 1.53462 3.69549V3.63418C1.53462 3.20356 1.80663 2.87683 2.17989 2.87683H3.55532L4.5563 2.41582L3.55728 1.9548Z",
    fill: "#EAA73A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55728 1.9548H2.21725C1.42451 1.9548 0.666504 2.57419 0.666504 3.64942V4.3483C0.666504 4.91492 0.718611 5.33488 0.950469 5.89036C1.36765 6.88498 2.33654 7.87779 3.85468 7.93104L4.72769 7.45938L3.6007 6.98772C3.3187 6.95036 2.446 6.76028 1.88593 5.795C1.47186 5.08287 1.53462 3.95487 1.53462 3.69549V3.63418C1.53462 3.20356 1.80663 2.87683 2.17989 2.87683H3.55532L4.5563 2.41582L3.55728 1.9548Z",
    fill: "url(#paint0_linear_11655_96250)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7829 1.95218H12.4483L11.4483 2.41549L12.4483 2.87879H13.8207C14.1942 2.87879 14.4662 3.20487 14.4662 3.63614V3.69761C14.4662 3.95487 14.5283 5.08156 14.1144 5.79499C13.5563 6.75635 12.6903 6.94839 12.4022 6.98706L11.2739 7.45741L12.1456 7.92776C13.6636 7.87435 14.6323 6.88104 15.0497 5.88692C15.2817 5.33357 15.3336 4.91098 15.3336 4.34485V3.64483C15.3336 2.5714 14.5769 1.95218 13.7829 1.95218Z",
    fill: "#FFD340"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7829 1.95218H12.4483L11.4483 2.41549L12.4483 2.87879H13.8207C14.1942 2.87879 14.4662 3.20487 14.4662 3.63614V3.69761C14.4662 3.95487 14.5283 5.08156 14.1144 5.79499C13.5563 6.75635 12.6903 6.94839 12.4022 6.98706L11.2739 7.45741L12.1456 7.92776C13.6636 7.87435 14.6323 6.88104 15.0497 5.88692C15.2817 5.33357 15.3336 4.91098 15.3336 4.34485V3.64483C15.3336 2.5714 14.5769 1.95218 13.7829 1.95218Z",
    fill: "url(#paint1_linear_11655_96250)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7829 1.95218H12.4483L11.4483 2.41549L12.4483 2.87879H13.8207C14.1942 2.87879 14.4662 3.20487 14.4662 3.63614V3.69761C14.4662 3.95487 14.5283 5.08156 14.1144 5.79499C13.5563 6.75635 12.6903 6.94839 12.4022 6.98706L11.2739 7.45741L12.1456 7.92776C13.6636 7.87435 14.6323 6.88104 15.0497 5.88692C15.2817 5.33357 15.3336 4.91098 15.3336 4.34485V3.64483C15.3336 2.5714 14.5769 1.95218 13.7829 1.95218Z",
    fill: "url(#paint2_radial_11655_96250)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29215 13.4845V9.2185L8.71821 9.21506V13.4845H10.847C11.2424 13.4845 11.5638 13.8232 11.5638 14.2405V14.244C11.5638 14.6613 11.2424 15 10.847 15H5.16479C4.77006 15 4.44873 14.6613 4.44873 14.244V14.2405C4.44873 13.8232 4.77006 13.4845 5.16479 13.4845H7.29215Z",
    fill: "url(#paint3_linear_11655_96250)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29215 13.4845V9.2185L8.71821 9.21506V13.4845H10.847C11.2424 13.4845 11.5638 13.8232 11.5638 14.2405V14.244C11.5638 14.6613 11.2424 15 10.847 15H5.16479C4.77006 15 4.44873 14.6613 4.44873 14.244V14.2405C4.44873 13.8232 4.77006 13.4845 5.16479 13.4845H7.29215Z",
    fill: "url(#paint4_radial_11655_96250)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29215 13.4845V9.2185L8.71821 9.21506V13.4845H10.847C11.2424 13.4845 11.5638 13.8232 11.5638 14.2405V14.244C11.5638 14.6613 11.2424 15 10.847 15H5.16479C4.77006 15 4.44873 14.6613 4.44873 14.244V14.2405C4.44873 13.8232 4.77006 13.4845 5.16479 13.4845H7.29215Z",
    fill: "url(#paint5_radial_11655_96250)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4485 1.91941V1.95218V2.87879V6.38357C12.4487 6.58562 12.4333 6.78738 12.4024 6.98706L12.1491 7.90843C11.5903 9.26582 10.3077 10.2151 8.81558 10.2151H8.71825L7.2922 10.2185H7.18831C5.6895 10.2185 4.40338 9.26091 3.84807 7.89368L3.60081 6.98771C3.57044 6.78754 3.55527 6.58537 3.55542 6.38291V2.87683L3.55739 1.9548C3.57082 1.05669 4.03143 1 4.50072 1H11.5925C12.1352 1 12.4485 1.29806 12.4485 1.91941Z",
    fill: "#EA873A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4485 1.91941V1.95218V2.87879V6.38357C12.4487 6.58562 12.4333 6.78738 12.4024 6.98706L12.1491 7.90843C11.5903 9.26582 10.3077 10.2151 8.81558 10.2151H8.71825L7.2922 10.2185H7.18831C5.6895 10.2185 4.40338 9.26091 3.84807 7.89368L3.60081 6.98771C3.57044 6.78754 3.55527 6.58537 3.55542 6.38291V2.87683L3.55739 1.9548C3.57082 1.05669 4.03143 1 4.50072 1H11.5925C12.1352 1 12.4485 1.29806 12.4485 1.91941Z",
    fill: "url(#paint6_radial_11655_96250)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4485 1.91941V1.95218V2.87879V6.38357C12.4487 6.58562 12.4333 6.78738 12.4024 6.98706L12.1491 7.90843C11.5903 9.26582 10.3077 10.2151 8.81558 10.2151H8.71825L7.2922 10.2185H7.18831C5.6895 10.2185 4.40338 9.26091 3.84807 7.89368L3.60081 6.98771C3.57044 6.78754 3.55527 6.58537 3.55542 6.38291V2.87683L3.55739 1.9548C3.57082 1.05669 4.03143 1 4.50072 1H11.5925C12.1352 1 12.4485 1.29806 12.4485 1.91941Z",
    fill: "url(#paint7_radial_11655_96250)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4485 1.91941V1.95218V2.87879V6.38357C12.4487 6.58562 12.4333 6.78738 12.4024 6.98706L12.1491 7.90843C11.5903 9.26582 10.3077 10.2151 8.81558 10.2151H8.71825L7.2922 10.2185H7.18831C5.6895 10.2185 4.40338 9.26091 3.84807 7.89368L3.60081 6.98771C3.57044 6.78754 3.55527 6.58537 3.55542 6.38291V2.87683L3.55739 1.9548C3.57082 1.05669 4.03143 1 4.50072 1H11.5925C12.1352 1 12.4485 1.29806 12.4485 1.91941Z",
    fill: "url(#paint8_radial_11655_96250)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11655_96250",
    x1: 3.49059,
    y1: 4.01211,
    x2: 2.15122,
    y2: 3.73007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D27840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D27840",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11655_96250",
    x1: 12.7631,
    y1: 6.81941,
    x2: 15.1368,
    y2: 5.24058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC551",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_11655_96250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.7839 4.67719) rotate(-28.1739) scale(2.76987 3.10818)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#FFEC6A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEC6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11655_96250",
    x1: 9.0323,
    y1: 14.0433,
    x2: 5.02158,
    y2: 14.0433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC33A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB7B3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_11655_96250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.25573 12.1075) rotate(90) scale(1.56209 1.51036)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#FFE469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE469",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_11655_96250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.9655 14.4853) rotate(150.613) scale(1.77619 2.61978)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD34D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_11655_96250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.62118 1.71326) rotate(83.6676) scale(7.87726 5.08533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FFFA73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFA73",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_11655_96250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.67282 1) rotate(90) scale(0.446558 5.01805)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF45B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF45B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_11655_96250",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.1395 2.74352) rotate(121.712) scale(8.33781 8.01924)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.787,
    stopColor: "#C55D73",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C55D73"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTgpTrophy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_tgp_trophy.be8b670452bf3dfac3efd3df78721ae1.svg";